// olap-client/src/components/NavBar.js
import React, { useContext } from "react";
import { Context } from "../index";
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from "react-router-dom";
import { ADMIN_ROUTE, INDEX_ROUTE, LOGIN_ROUTE } from "../utils/consts";
import { observer } from 'mobx-react-lite';
import { useNavigate } from "react-router-dom";
import { unsubscribeFromPush } from '../utils/pushNotifications';

const NavBar = observer(() => {
    const { user } = useContext(Context);
    const navigate = useNavigate();

    const logOut = async () => {
        console.log('🚪 [Logout] Starting logout process...');
        
        // 1. Отписываемся от push ПЕРЕД очисткой токена
        try {
            await unsubscribeFromPush();
            console.log('✅ [Logout] Push unsubscribed');
        } catch (e) {
            console.error('❌ [Logout] Push unsubscribe error:', e);
        }
        
        // 2. Очищаем состояние
        user.setUser({});
        user.setIsAuth(false);
        
        // 3. Очищаем localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // 4. Переходим на главную
        navigate(INDEX_ROUTE);
    };

    return (
        <Navbar bg="dark" variant="dark">
            <Container>
                {
                (user.isAuth && (user.user.role === 'ADMIN' || user.user.role === 'RUK+')) ?
                    <>
                        <NavLink style={{"color":"white","fontWeight":"800"}} to={INDEX_ROUTE}>Aktiv-kredit</NavLink>
                        <Nav className="ml-auto">
                            <NavLink role="button" className="nav-link" to={ADMIN_ROUTE}>Настройки</NavLink>
                            <Nav.Link onClick={() => logOut()}>Выйти</Nav.Link>
                        </Nav>
                    </>
                    : (user.isAuth && user.user.role === 'RUK') ?
                    <>
                        <NavLink style={{"color":"white","fontWeight":"800"}} to={INDEX_ROUTE}>Aktiv-kredit</NavLink>
                        <Nav className="ml-auto">
                            <Nav.Link onClick={() => logOut()}>Выйти</Nav.Link>
                        </Nav>
                    </>
                    : (user.isAuth && user.user.role === 'MAN') ?
                    <>
                        <NavLink style={{"color":"white","fontWeight":"800"}} to={INDEX_ROUTE}>Aktiv-kredit</NavLink>
                        <Nav className="ml-auto">
                            <Nav.Link onClick={() => logOut()}>Выйти</Nav.Link>
                        </Nav>
                    </>
                    :
                    <>
                        <NavLink style={{"color":"white","fontWeight":"800"}} to={LOGIN_ROUTE}>Aktiv-kredit</NavLink>
                        <Nav className="ml-auto">
                            <NavLink role="button" className="nav-link" to={LOGIN_ROUTE}>Авторизация/Регистрация</NavLink>
                        </Nav>
                    </>
                }     
            </Container>
        </Navbar>
    );
});

export default NavBar;